module.exports = __webpack_public_path__ + "static/media/pumpkin.9f214979.svg";